@if (!config.hideActions) {
  <div
    [ngClass]="{
      FormGroupArrayAccordionContent__AccordionAction:
        config?.showFormWithAccordion,
    }"
  >
    @if (
      (formArray?.length > 1 && !(index === 0 && config.protectMain)) ||
      config.allowEmpty
    ) {
      <icon
        [name]="config.actionIcon || 'close'"
        [config]="{ type: 'pointer', fill: 'none' }"
        (click)="removeGroup(index)"
        tabindex="0"
        (keydown.enter)="removeGroup(index)"
      >
      </icon>
    }
  </div>
}
